// region locale currency formatting

const currencyFormatter = new Intl.NumberFormat([], {
  style: "currency",
  currency: window.c_ActiveCurrency,
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function currencyFormat(value: number) {
  return currencyFormatter.format(value);
}

export function currencyFormatRange(minVal: number, maxVal: number) {
  return currencyFormatter.formatRange(minVal, maxVal);
}

export const currencyUnit =
  currencyFormatter.formatToParts(42).find((part) => part.type === "currency")?.value || window.c_ActiveCurrency;

// endregion locale currency formatting

// region metric unit formatting

const unitFormatter = Intl.NumberFormat([], {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  style: "unit",
  unit: "gram",
});

export function unitFormat(value: number) {
  return unitFormatter.format(value);
}

export function unitFormatRange(minVal: number, maxVal: number) {
  return unitFormatter.formatRange(minVal, maxVal);
}

// endregion metric unit formatting

// region percent formatting

const percentFormatter = Intl.NumberFormat([], {style: "percent"});

export function percentFormat(percent) {
  return percentFormatter.format(percent / 100);
}

// endregion percent formatting
